import AppUtils from 'src/utils/AppUtils';
import GenericDB from './generic-db';

const INVITATION_EMAIL_TEMPLATE = 'invitation_v2';

export default class TriggerMailsDB extends GenericDB {
  constructor() {
    super('triggerMails');
  }

  /**
  * Send an e-mail based on a template
  * @param {array} toEmails
  * @param {string} template
  * @param {object} data
  * @param {{ replyTo?: string }} [options] - replyTo overrides the extension's DEFAULT_REPLY_TO for
  * skip param to keep the platform default
  */
  async sendMail(toEmails, template, data, { replyTo } = {}) {
    const mailObj = {
      to: toEmails,
      template: {
        name: template,
        data,
      },
      ...(replyTo && { replyTo }),
    };
    return this.create(mailObj);
  }

  /**
   * Send the invitation email to a newly invited user.
   * @param {object} params
   * @param {string} params.email - recipient's email
   * @param {string} params.region
   * @param {string} [params.name]
   * @param {string} [params.invitePage]
   * @param {boolean} [params.requireLoginMethod]
   * @param {string} [params.loginMethod]
   * @param {string} [params.clinicName]
   * @param {string} params.replyTo - sender's email
   */
  async sendInvitationMail({
    email, region, name, invitePage = 'signup', requireLoginMethod, loginMethod, clinicName, replyTo,
  }) {
    const signupQueryParams = new URLSearchParams({
      email,
      region,
      ...(name && { name }),
      ...(requireLoginMethod && loginMethod ? { loginMethod } : {}),
    });

    const templateData = {
      recipient_email: email,
      signup_link: `${AppUtils.getCurrentOrigin()}/#/${invitePage}?${signupQueryParams.toString()}`,
      clinic_name: clinicName ?? '',
    };

    return this.sendMail([email], INVITATION_EMAIL_TEMPLATE, templateData, { replyTo });
  }
}
